import React, { useLayoutEffect, useState } from "react";
import Home from "./Home";
import HomeMobile from "./HomeMobile";
import "./style.css";

export const Layout = () => {
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth < 860) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return <>{isMobile ? <HomeMobile /> : <Home />}</>;
};
